import React, { useContext } from "react";
import AuthContext from "../../context/userAuth.context";
const PreviewShapes = ({
  setLoadCounter,
  value,
  TickerStart,
  TickerPosition,
  zInd,
  CanvasDisplay,
}) => {
  const isLoaded = () => {
    if (sessionStorage.getItem("LoadCounter")) {
      let array = JSON.parse(sessionStorage.getItem("LoadCounter"));
      array.push(value.previewKey);
      sessionStorage.setItem("LoadCounter", JSON.stringify(array));
      setLoadCounter(array);
    }
  };
  const { authenticationData, Role } = useContext(AuthContext);

  return (
    <>
      {value.opc === 1 && (
        <div
          className={"changer EditStart " + value.InClass + value.OutClass}
          style={{
            display: !CanvasDisplay
              ? value.player
                ? "inline-block"
                : "none"
              : TickerStart
              ? value.startPositionOnTimeline <= TickerPosition &&
                value.startPositionOnTimeline + value.widthOnTimeline >=
                  TickerPosition
                ? "inline-block"
                : "none"
              : value.startPositionOnTimeline + value.startTransitionWidth <=
                  TickerPosition &&
                value.startPositionOnTimeline +
                  value.widthOnTimeline -
                  value.startTransitionWidth >=
                  TickerPosition
              ? "inline-block"
              : "none",
            height: value.height,
            width: value.width,
            VendorAnimationDuration: ".5s",
            zIndex: zInd,
            left: value.x,
            top: value.y,
            position: "absolute",
            transform: CanvasDisplay
              ? `rotate(${value.rotateAngle}deg) ` + value.flip
              : "",
          }}
        >
          <span style={{ width: "100%", height: "100%" }}>
            <img
              onLoad={isLoaded}
              className={"ImgTag"}
              draggable={false}
              tabIndex="0"
              src={authenticationData.ApiBaseURL + "/" + value.ShapePath}
              style={{
                transform: !CanvasDisplay
                  ? ` rotate(${value.rotateAngle}deg) ` + value.flip
                  : "",
                opacity: value.opacity,
                position: "absolute",
                top: "0",
                left: "0",
                zIndex: -1,
              }}
            />
          </span>
        </div>
      )}
    </>
  );
};
export default PreviewShapes;
